var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"icon":[("" + _vm.iconStyle), 'box-archive'],"tooltip-label":_vm.$t('general.archive')},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }